<template>
	<div class="cbs-textarea-control">
		<legend class="flex justify-between items-center">
			<div>{{ localValue.title }}<span class="text-danger" v-if="!localValue.is_optional">&nbsp;*</span>:</div>
			<cbs-hint
				v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.ICON"
				:data="localValue.description && localValue.description.value"
			/>
		</legend>

		<div class="my-1" v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.TOP">
			{{ localValue.description && localValue.description.value }}
		</div>
		<cbs-textarea
			v-if="localTypeAttributeValue === $constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.TEXTAREA.TYPE_RAW"
			class="mb-0"
			data-vv-delay="100"
			v-model="localValue.value"
			v-validate="!localValue.is_optional ? 'required' : ''"
			:data-vv-as="localValue.title"
			:autosize="{ minRows: 3, maxRows: 4 }"
			:name="`${localValue.title}-${localValue.id}`"
			:placeholder="`${$t('Actions.Input')} ${localValue.title.toLowerCase()}`"
		/>
		<cbs-editor
			v-else-if="localTypeAttributeValue === $constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.TEXTAREA.TYPE_RICHTEXT"
			data-vv-delay="100"
			v-model="localValue.value"
			class="cbs-textarea-control_editor"
			v-validate="!localValue.is_optional ? 'required' : ''"
			:data-vv-as="localValue.title"
			:name="`${localValue.title}-${localValue.id}`"
			:placeholder="`${$t('Actions.Input')} ${localValue.title.toLowerCase()}`"
		/>
		<span class="text-danger text-sm">{{ errors.first(`${localValue.title}-${localValue.id}`) }}</span>
		<div class="my-1" v-if="localValue.description && localValue.description.enable && localValue.description.position === $constant.DYNAMIC_FORM_FIELD_INFO_POSITION.BOTTOM">
			{{ localValue.description && localValue.description.value }}
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import CbsHint from "@/components/cbs-hint/CbsHint.vue";
import CbsEditor from "@/components/cbs-editor/CbsEditor";

export default {
	name: "TextareaControl",
	inject: ["parentValidator"],
	components: {
		vSelect,
		CbsHint,
		CbsEditor
	},
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop =>
				prop.hasOwnProperty("id") &&
				prop.hasOwnProperty("value") &&
				prop.hasOwnProperty("title") &&
				prop.hasOwnProperty("control") &&
				prop.hasOwnProperty("children") &&
				prop.hasOwnProperty("attributes") &&
				prop.hasOwnProperty("is_optional") &&
				prop.hasOwnProperty("description")
		}
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		localAttributesValue() {
			const attributesValue = typeof this.localValue.attributes === "string" ? JSON.parse(this.localValue.attributes) : this.localValue.attributes;
			return attributesValue;
		},
		localTypeAttributeValue() {
			return this.localAttributesValue.type || this.$constant.DYNAMIC_FORM_FIELD_CONTROL_TYPES.TEXTAREA.TYPE_RAW;
		}
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>

<style lang="scss" scoped>
.cbs-textarea-control {
	.cbs-textarea-control_editor {
		::v-deep .ql-editor {
			color: var(--color-black);
			min-height: 80px;
			max-height: 40vh;
		}
	}
}
</style>
